import {Routes} from '@angular/router';

export const goodsDetailPropertyManagementRoutes: Routes = [
      {
        path: 'serviceGoodsDetailPropertyManagement',
        loadComponent: () => import('./goods-detail-property-management.component').then(m => m.GoodsDetailPropertyManagementComponent),
        data: { title: '详情页参数' },
      },
];
